// extracted by mini-css-extract-plugin
export default {"wrapper":"PR_y1_Y","statusLimitsList":"R4LwL6V"};